export default [
  {
    layout: false,
    path: "/user/login",
    name: "登录",
    component: "./user/login",
  },
  {
    path: "/dashboard",
    name: "首页",
    icon: "icon-home-roof",
    component: "./dashboard",
  },
  {
    path: "/data-centers",
    name: "数据中心",
    icon: "icon-trending-4",
    routes: [
      {
        path: "/data-centers/dashboard",
        name: "大盘概览",
        component: "./data-centers/dashboard",
      },
      {
        path: "/data-centers/advertiser-performance",
        name: "广告主表现报表",
        component: "./data-centers/advertiser-performance",
      },
      {
        path: "/data-centers/media-traffic-analysis",
        name: "媒体分析表",
        component: "./data-centers/media-traffic-analysis",
      },
      {
        path: "/data-centers/advertiser-media-combination",
        name: "上下游组合表",
        component: "./data-centers/adv-media-combination",
      },
      {
        path: "/data-centers/device-os-region-analysis",
        name: "地域分析表",
        component: "./data-centers/device-os-region",
      },
    ],
  },
  {
    path: "/ad",
    name: "推广管理",
    icon: "icon-rocket",
    component: "./ad",
  },
  {
    path: "/advertiser-management",
    name: "广告主管理",
    icon: "icon-vibe-coding-star",
    routes: [
      {
        path: "/advertiser-management/advertisers",
        name: "广告主列表",
        component: "./advertiser-management/advertisers",
      },
      {
        path: "/advertiser-management/advertiser-approval",
        name: "广告主审核",
        component: "./advertiser-management/advertiser-approval",
      },
      {
        path: "/advertiser-management/advertisers/create",
        name: "广告主新增",
        component: "./advertiser-management/advertisers/detail",
        hideInMenu: true,
      },
      {
        path: "/advertiser-management/advertisers/edit",
        name: "广告主编辑",
        component: "./advertiser-management/advertisers/detail",
        hideInMenu: true,
      },
    ],
  },
  {
    path: "/media",
    name: "媒体管理",
    icon: "icon-layers-three",
    routes: [
      {
        path: "/media/media-setting",
        name: "媒体配置",
        component: "./media/media-setting",
      },
      // {
      //   path: '/media/application-manager',
      //   name: '应用管理',
      //   component: './media/application-manager',
      //   access: 'auth'
      // },
      {
        path: "/media/application-data",
        name: "应用管理",
        component: "./media/application-data",
      },
      {
        path: "/media/advertising-position",
        name: "尺寸管理",
        component: "./media/advertising-position",
      },
    ],
  },
  {
    path: "/financial-management",
    name: "财务管理",
    icon: "icon-wallet-3",
    routes: [
      {
        path: "/financial-management/financial-statement",
        name: "财务报表",
        component: "./financial-management/financial-statement",
      },
      {
        path: "/financial-management/recharge-refund",
        name: "充值/退款",
        component: "./financial-management/recharge-refund",
      },
      {
        path: "/financial-management/financial-flow",
        name: "财务流水",
        component: "./financial-management/financial-flow",
      },
    ],
  },
  {
    path: "/public-configuration",
    name: "公共配置",
    icon: "icon-settings-slider-hor",
    routes: [
      {
        path: "/public-configuration/share-proportionally",
        name: "分成比例",
        component: "./public-configuration/share-proportionally",
      },
      {
        path: "/public-configuration/weight-rules",
        name: "权重规则配置",
        component: "./public-configuration/weight-rules",
      },
    ],
  },
  {
    path: "/permissions-management",
    name: "权限管理",
    icon: "icon-private",
    routes: [
      {
        path: "/permissions-management/role",
        name: "角色管理",
        component: "./permissions/role",
      },
      {
        path: "/permissions-management/user",
        name: "用户管理",
        component: "./permissions/user",
      },
      {
        path: "/permissions-management/permission",
        name: "权限管理",
        component: "./permissions/permission",
      },
    ],
  },
  // 设置首页
  {
    path: "/",
    wrappers: [],
  },
  {
    redirect: "/",
    path: "/*",
    wrappers: ["@/wrappers/auth"],
  },
];
